import type {
  OnboardingForm,
  PlatformCreateSchoolStep,
} from "../types/platformCreateSchool.types";

export const PLATFORM_CREATE_SCHOOL_DRAFT_KEY =
  "platform_school_onboarding_phase1_draft";

export const PLATFORM_CREATE_SCHOOL_STEPS: PlatformCreateSchoolStep[] = [
  "School Identity",
  "Location & Contact",
  "Management Admin",
  "Academic Baseline",
  "Modules & Limits",
  "Review & Confirm",
];

export const INITIAL_PLATFORM_CREATE_SCHOOL_FORM: OnboardingForm = {
  school_name: "",
  school_code: "",
  board: "",
  category: "",
  medium: "English",
  school_type: "co_educational",
  established_year: "",
  affiliation_number: "",
  udise_code: "",
  street: "",
  area: "",
  city: "",
  district: "",
  state: "",
  pin_code: "",
  country: "India",
  landmark: "",
  school_phone: "",
  school_email: "",
  website: "",
  admin_first_name: "",
  admin_last_name: "",
  admin_designation: "",
  admin_department: "",
  admin_employee_id: "",
  admin_phone: "",
  admin_phone_country: "+91",
  admin_email: "",
  language_preference: "en",
  timezone: "Asia/Kolkata",
  current_session: "",
  academic_start_month: "April",
  academic_end_month: "March",
  working_days_per_week: "6",
  class_levels: ["1", "2", "3", "4", "5"],
  lkg_available: false,
  ukg_available: false,
  pre_nursery_available: false,
  modules_enabled: ["attendance", "exams", "communication", "reports"],
  max_students: "1000",
  max_teachers: "60",
  max_staff: "40",
  storage_limit_gb: "100",
  api_access: false,
  bulk_operations: true,
  custom_reports: false,
};

export const CLASS_LEVEL_OPTIONS = [
  "Pre Nursery",
  "LKG",
  "UKG",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
];

export const MODULE_OPTIONS = [
  "attendance",
  "exams",
  "fees",
  "library",
  "transport",
  "hostel",
  "hr",
  "accounting",
  "communication",
  "reports",
];

export const MONTH_OPTIONS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
